import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        icon: {
            height: '20px !important',
            width: '20px !important',
        },
    }
})

export default useStyles
